import React, { useState } from 'react'
import { Box, IconButton, TableCell, TableRow, Chip } from '@mui/material'
import Delete from './Delete'
import Form from './Form'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { usePatchHtgIncentive } from '../../api/htg-incentive'

const Row = ({ data, refetch }) => {
  const [editing, setEditing] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)

  const formDefaultValues = {
    ...data,
    extendedDateEnabled: !!data.extendedDate,
    extendedDate: data.extendedDate?.split('T')[0], // native datepicker only supports yyyy-mm-dd
  }

  return (
    <>
      <TableRow>
        <TableCell>{data.name}</TableCell>
        <TableCell>
          {[
            { label: 'HWT', value: data.hwtTarget },
            { label: 'HTE', value: data.hteTarget },
            { label: 'HTL', value: data.htlTarget },
            { label: 'EKT', value: data.ektTarget },
            { label: 'HTB', value: data.htbTarget },
          ]
            .filter((item) => item.value)
            .map(({ label, value }) => (
              <Box key={label} component='span' display='block'>
                {label}: {value}
              </Box>
            ))}
        </TableCell>
        <TableCell>{data.primarySalesId}</TableCell>
        <TableCell>{data.type}</TableCell>
        <TableCell>
          <Chip
            label={data.bonusEnabled ? 'Enabled' : 'Disabled'}
            size='small'
            color={data.bonusEnabled ? 'success' : 'default'}
          />
        </TableCell>
        <TableCell>
          <IconButton color='primary' onClick={() => setEditing(true)} size='small'>
            <EditIcon />
          </IconButton>
          <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
      <Form
        defaultValues={formDefaultValues}
        open={editing}
        setOpen={setEditing}
        refetch={refetch}
        api={usePatchHtgIncentive}
        isEdit={true}
      />
    </>
  )
}

export default Row
